import { Box, ChakraProvider, LightMode, extendTheme } from "@chakra-ui/react";
import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "routes.js";
import theme from "theme/theme.js";
import { mode } from "@chakra-ui/theme-tools";

const globalStyles = {
  styles: {
    global: (props) => ({
      body: {
        bg: mode("gray.50", "gray.50")(props),
        fontFamily: 'Helvetica, sans-serif',
      },
      html: {
        fontFamily: 'Helvetica, sans-serif',
      },
    }),
  },
};

const publicTheme = extendTheme({ ...globalStyles }, theme);

export default function PublicLayout() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === "account") {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/public") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <ChakraProvider theme={publicTheme} resetCss={false}>
      <LightMode>
        <Box w="100%">
          <Switch>{getRoutes(routes)}</Switch>
        </Box>
      </LightMode>
    </ChakraProvider>
  );
}
